module.exports = __webpack_public_path__ + "static/container.1c7db963.png";